module.exports = __webpack_public_path__ + "static/media/new1.a4f757ac.png";